<template>
  <div class="checkinfo" v-if="checkData">
    <el-row>
      <el-col :span="8">
        <div :class="{'pb20':isnotCheckResult}">审批人：{{checkData.operator}}</div>
      </el-col>
      <el-col :span="8">
        <div :class="{'pb20':isnotCheckResult}">审批时间：{{checkData.auditDate | formatData}}</div>
      </el-col>
      <el-col :span="8">
        <div :class="{'pb20':isnotCheckResult}">所属部门：{{checkData.orgName}}</div>
      </el-col>
    </el-row>
    <!--  没有审批结果  -->
    <el-row v-if="isnotCheckResult">
      <el-col :span="8">
        <div>审批结果：<span :style="{color:checkStateEx[checkData.state] && checkStateEx[checkData.state].color}">{{checkStateEx[checkData.state] && checkStateEx[checkData.state].label}}</span>
        </div>
      </el-col>
      <el-col :span="16">
        <div>备注：{{checkData.auditMark | isNoData}}</div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { checkStateEx } from '@/meun/date'

export default {
  name: 'checkInfoModule',
  props: {
    checkData: {
      type: Object,
      default: () => {
      }
    },
    isnotCheckResult: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      checkStateEx
    }
  }
}
</script>

<style scoped lang="less">

</style>
